import React from 'react';

const RightSlider = () => {
    return (
        <>
            <div id="my-carousel" class="carousel slide carousel-fade" data-ride="carousel" data-interval="5000">
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <a href="http://sh.st/st/4152f4bc9d1aca5236b3ab14a650a949/vilton.ltd/partner/viltonzaiss" target="_blank" rel="noreferrer">
                            <img class="d-block w-100" src="https://vilton.ltd/assets/img/a/vertical_en.gif" width="100%" height="450" alt="vilton.ltd"/>
                        </a>
                    </div>
                    <div class="carousel-item">
                        <a href="http://sh.st/st/4152f4bc9d1aca5236b3ab14a650a949/hashshiny.io/r/CI8398112" target="_blank" rel="noreferrer">
                            <img class="d-block w-100" src="https://hashshiny.io/uploads/banner/15382132396.gif" width="100%" height="450" alt="hashshiny.io"/>
                        </a>
                    </div>
                    <div class="carousel-item">
                        <a href="http://sh.st/st/4152f4bc9d1aca5236b3ab14a650a949/pipeflare.io/r/40bx" target="_blank" rel="noreferrer">
                            <img class="d-block w-100" src="./images/Pipeflare-promo-banner-gaming_300x600.jpg" width="100%" height="450" alt="pipeflare.io"/>
                        </a>
                    </div>
                </div>
            </div>           
        </>
    )
};

export default RightSlider;
